(function () {
	if (window.location.hash) {
		// Smooth scroll to the element after page load
		setTimeout(() => {
			document
				.getElementById(window.location.hash.substring(1))
				.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
					inline: 'center',
				});
		}, 3000);
	}
})();

/* 
HOW TO USE:
  <simple-video>
	.... content ....
	<div data-image-wrapper>
	  <iframe src="https://www.youtube.com/embed/..." 
		frameborder="0" 
		allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
		allowfullscreen></iframe>
	</div>
	.... content ....
  </simple-video>

  TODO: Enhance this component to support multiple video types
*/

class simpleVideo extends HTMLElement {
	constructor() {
		super();
		this.iframe = this.querySelector('iframe');
		this.video = this.querySelector('video');
		this.wrapper = this.querySelector('[data-image-wrapper]');
		this.placeholder = this.querySelector('[data-image-wrapper] img');

		if (!this.hasImageWrapper()) return;

		if (this.iframe) this.initIframe();
		if (this.video) this.initVideo();
	}

	videoToggle(playBtn) {
		if (this.video.paused == true) {
			this.video.play();
			playBtn.style.opacity = 0;
		} else {
			this.video.pause();
			playBtn.style.opacity = 1;
		}
	}

	createPlayButton() {
		const playBtn = document.createElement('button');
		playBtn.classList.add('video__play-btn');
		playBtn.setAttribute('aria-label', 'Play video');
		playBtn.innerHTML =
			'<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-play" viewBox="0 0 30 30"><path d="M11.59 8.254l10.478 6.79-10.478 6.79V8.254zm3.395 21.717C6.732 29.97 0 23.239 0 14.985 0 6.732 6.732 0 14.985 0c8.254 0 14.986 6.732 14.986 14.985 0 8.254-6.732 14.986-14.986 14.986zm0-28.8c-7.61 0-13.814 6.205-13.814 13.814 0 7.61 6.205 13.815 13.814 13.815 7.61 0 13.815-6.205 13.815-13.815 0-7.61-6.205-13.814-13.815-13.814z"></path></svg>';
		this.wrapper.prepend(playBtn);

		playBtn.addEventListener('click', () => {
			this.dataset.playing = true;
			const playUrl = this.iframe?.src ?? this.video?.src;
			if (this.iframe) {
				this.iframe.src = playUrl.replace('?autoplay=0', '?autoplay=1');
				playBtn.style.display = 'none';
			}

			if (this.placeholder) this.placeholder.remove();

			if (this.video) {
				this.video.addEventListener('click', () => {
					this.videoToggle(playBtn);
				});

				this.videoToggle(playBtn);
			}
		});
	}

	initIframe() {
		// create placeholder image if youtube video
		if (this.iframe.src.includes('youtube')) {
			if (!this.placeholder) {
				this.placeholder = document.createElement('img');
				let id = this.iframe.src;

				if (id.includes('?')) id = id.split('?v=')[1];
				if (id.includes('embed')) id = id.split('embed/')[1];
				this.placeholder.src = `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
				this.placeholder.setAttribute('alt', 'Video thumbnail');
				this.placeholder.setAttribute('loading', 'lazy');
				this.wrapper.prepend(this.placeholder);
			}

			if (this.iframe) this.iframe.src += '?autoplay=0';
			// create play button
			this.createPlayButton();
		}
	}

	initVideo() {
		this.createPlayButton();
	}

	hasImageWrapper() {
		if (!this.wrapper) {
			console.error(
				"simple-video: No wrapper element found. Please add a wrapper element for iframe with the attribute 'data-image-wrapper' to your simple-video component."
			);
			return false;
		}

		return true;
	}
}

customElements.define('simple-video', simpleVideo);

class SwiperSlider extends HTMLElement {
	constructor() {
		super();
		this.swiper = null;
		this.slidesPerView = this.getAttribute('slides-per-view') || 1;
		this.loop = this.getAttribute('loop') ? false : true;
		this.centerInsuficientSlider = this.loop === false ? true : false;

		this.productIndex = this.getAttribute('product-index') || false;

		this.options = {
			// default options
			loop: this.loop,
			navigation: {},
			breakpoints: {
				640: {
					slidesPerView: 2,
					slidesPerGroup: 2,
				},
				768: {
					slidesPerView: 3,
					slidesPerGroup: 3,
				},
				1024: {
					slidesPerView: 4,
					slidesPerGroup: 4,
				},
			},
			centerInsufficientSlides: this.centerInsuficientSlider,
			slidesPerView: this.slidesPerView,
			loopAddBlankSlides: false,
			spaceBetween: this.getAttribute('spaceBetween') || 0,
			slidesPerGroup: Number(this.getAttribute('slides-per-group')) || 1,
		};
	}

	connectedCallback() {
		// load Swiper library if it's not already loaded
		if (typeof Swiper === 'undefined') {
			const css = document.createElement('link');
			css.rel = 'stylesheet';
			css.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
			css.onload = this.initSwiper.bind(this);
			document.head.appendChild(css);

			const js = document.createElement('script');
			js.src =
				'https://cdn.jsdelivr.net/npm/swiper@11/swiper-element-bundle.min.js';
			js.onload = this.initSwiper.bind(this);
			document.head.appendChild(js);
		} else {
			this.initSwiper();
		}
	}

	disconnectedCallback() {
		// destroy swiper slider when custom element is removed from DOM
		this.swiper.destroy();
	}

	initSwiper() {
		if (typeof Swiper === 'undefined') return;
		// create swiper container and wrapper elements
		const container = document.createElement('div');
		container.classList.add('swiper-container');
		const wrapper = document.createElement('div');
		wrapper.classList.add('swiper-wrapper');

		// add slides to wrapper element
		const slides = this.querySelectorAll('[data-slide]');
		slides.forEach((slide) => {
			slide.classList.add('swiper-slide');
			wrapper.appendChild(slide);
		});

		// append container and wrapper elements to custom element
		container.appendChild(wrapper);
		this.appendChild(container);
		// initialize swiper slider
		this.swiper = new Swiper(container, this.options);
	}

	decodeHTMLEntities(encodedString) {
		const tempElement = document.createElement('div');
		tempElement.innerHTML = encodedString;
		return tempElement.textContent;
	}

	static get observedAttributes() {
		return [
			'loop',
			'navigation',
			'breakpoints',
			'slides-per-view',
			'autoplay',
			'spaceBetween',
		];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		// update options when observed attributes change
		if (name === 'loop') {
			this.options.loop = newValue !== null;
		} else if (name === 'navigation') {
			let right = '.input-icon-arrow-right';
			let left = '.input-icon-arrow-left';
			if (this.productIndex) {
				right = `.input-icon-arrow-right--${this.productIndex}`;
				left = `.input-icon-arrow-left--${this.productIndex}`;
			}
			this.options.navigation =
				newValue !== null
					? {
						nextEl: right,
						prevEl: left,
					}
					: false;
		} else if (name === 'breakpoints') {
			this.options.breakpoints = JSON.parse(newValue);
		} else if (name === 'slides-per-view') {
			this.options.slidesPerView = parseInt(newValue);
		} else if (name === 'autoplay') {
			this.options.autoplay =
				newValue !== null
					? {
						delay: parseInt(newValue),
					}
					: false;
		} else if (name === 'spaceBetween') {
			this.options.spaceBetween = parseInt(newValue);
		}

		// reinitialize swiper slider with updated options
		if (this.swiper) {
			this.swiper.destroy();
			this.swiper = new Swiper(
				this.querySelector('.swiper-container'),
				this.options
			);
		}
	}
}

customElements.define('swiper-slider', SwiperSlider);

// QuantitySelector

class QuantitySelector extends HTMLElement {
	constructor() {
		super();

		this.showAfter = this.dataset.showAfter;
		this.showAfterElement = document.querySelector(this.showAfter);
		this.stickyParent = this.parentNode.closest('[data-sticky-atc]');

		this.async = this.dataset.atcAsync;
		this.asyncElements = document.querySelectorAll(
			`[data-atc-async="${this.async}"]`
		);
		this.quantityInput = this.querySelector('[data-quantity]');
		this.decreaseButton = this.querySelector('[data-decrease]');
		this.increaseButton = this.querySelector('[data-increase]');

		this.quantityInput.addEventListener('change', () =>
			this.validateQuantity()
		);
		this.quantityInput.addEventListener('input', () => this.validateQuantity());
		this.increaseButton.addEventListener('click', () =>
			this.increaseQuantity()
		);
		this.decreaseButton.addEventListener('click', () =>
			this.decreaseQuantity()
		);

		if (this.showAfterElement && this.stickyParent) {
			this.setObserver();
		}
	}

	setObserver() {
		const observer = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach((entry) => {
					setTimeout(() => {
						if (entry.boundingClientRect.y <= 0) {
							this.stickyParent.classList.add('show-sticky-atc');
						} else {
							this.stickyParent.classList.remove('show-sticky-atc');
						}
					}, 250);
				});
			},
			{ threshold: 1 }
		);

		observer.observe(this.showAfterElement);
	}

	setValue(val) {
		if (this.asyncElements.length > 1) {
			this.asyncElements.forEach((ele) => {
				ele.querySelector('[data-quantity]').value = val;
				const decreaseButton = ele.querySelector('[data-decrease]');
				const increaseButton = ele.querySelector('[data-increase]');
				if (val > 1 && val < 5) {
					decreaseButton.classList.remove('disabled');
					increaseButton.classList.remove('disabled');
				}

				if (val <= 1) {
					decreaseButton.classList.add('disabled');
					increaseButton.classList.remove('disabled');
				}

				if (val >= 5) {
					increaseButton.classList.add('disabled');
					decreaseButton.classList.remove('disabled');
				}
			});
		} else {
			this.quantityInput.value = val;
		}
	}

	validateQuantity() {
		let val = parseInt(this.quantityInput.value);
		if (val > 5) val = 5;
		if (val < 1) val = 1;

		this.setValue(val);
	}

	increaseQuantity() {
		let val = parseInt(this.quantityInput.value);
		if (val < 5) {
			this.setValue(val + 1);
			this.decreaseButton.classList.remove('disabled');
		}
		if (val >= 4) {
			this.increaseButton.classList.add('disabled');
		}
	}

	decreaseQuantity() {
		let val = parseInt(this.quantityInput.value);
		if (val > 1) {
			this.setValue(val - 1);
			this.increaseButton.classList.remove('disabled');
		}
		if (val <= 2) {
			this.decreaseButton.classList.add('disabled');
		}
	}

	connectedCallback() {
		this.validateQuantity();
	}
}

customElements.define('quantity-selector', QuantitySelector);

// Custom Js Not Components

(function () {
	const variantButtons = document.querySelectorAll('[name="id_temp"]');

	if (variantButtons.length === 0) return;

	const price = document.querySelectorAll('[data-price]');

	variantButtons.forEach(function (button) {
		button.addEventListener('click', () => {
			const variantId = button.getAttribute('data-variant-id');
			document
				.querySelectorAll('[name="id"]')
				.forEach((input) => (input.value = variantId));

			var newUrl = [window.location.protocol, '//', window.location.host, window.location.pathname, '?variant=', variantId];
			var variantUrl = newUrl.join('');
			window.history.replaceState({ path: variantUrl }, '', variantUrl);

			let variantAvailable = JSON.parse(button.getAttribute('data-available'));
			document.querySelector('.pdp-atc-wrapper').classList[variantAvailable ? 'remove' : 'add']('hidden');
			document.querySelector('.sticky-atc').classList[variantAvailable ? 'remove' : 'add']('hidden');


			const variantComparePrice = button.getAttribute('data-variant-compare-price');
			const variantName = button.getAttribute('data-variant-name');
			const variantType = button.getAttribute('data-variant-type');
			const variantSkioPosition = button.getAttribute('data-skio-position');

			const skio = document.querySelector('.skio-plan-picker .subscribe-amount')
			const skioOneTime = document.querySelector('.skio-plan-picker .one-time-amount')

			const selectedInput = document.querySelector('input[name="id_temp"]:checked');
			const selectedId = Number(selectedInput?.dataset.variantId);

			const product = JSON.parse(document.getElementById('productJson').textContent);
			const selectedVariant = product.variants.find(variant => variant.id === Number(selectedId));

			if (price.length > 0) {
				price.forEach((ele) => {
					const price = ele.querySelector('.price');


					let subscriptionOption = document.querySelector('[name="skio-subscription-value"]:checked');
					let variantPrice = subscriptionOption && subscriptionOption?.getAttribute('data-skio') === 'subscription' && selectedVariant.selling_plan_allocations?.length
						? selectedVariant.selling_plan_allocations[0].price
						: selectedVariant.price;

					const salePrice = ele.querySelector('.sale-price');
					const name = ele.querySelector('.variant-name');
					const nameOnLabels = document.querySelectorAll('.label__name');
					const nameOnLabel = document.querySelector(`.label__name[data-type="${variantType}"]`);

					if (price) price.innerHTML = Shopify.formatMoney(variantPrice);
					if (salePrice) {
						if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
							salePrice.innerHTML = Shopify.formatMoney(selectedVariant.compare_at_price);
							salePrice.style.display = '';
						} else {
							salePrice.style.display = 'none';
						}
					}

					const hasDiscounts = document.querySelector('[discounts-applied]') ?? false
					const hasExclusionTag = document.querySelector('[discounts-exclusion-tag]') ?? false
					const exclusionTag = hasExclusionTag ? hasExclusionTag.getAttribute('discounts-exclusion-tag') : false
					let isExcluded = false

					if (exclusionTag) {
						const productTags = product.tags || [];
						isExcluded = productTags.includes(exclusionTag);
					}

					let discountPrice = 0
					if (hasDiscounts && !isExcluded) {
						discountPrice = (100 - Number(hasDiscounts.getAttribute('discounts-applied'))) / 100
						discountPrice = (selectedVariant.price * discountPrice);
						const comparePrice = selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price
							? selectedVariant.compare_at_price
							: selectedVariant.price;
						const html = `${`${Shopify.formatMoney(discountPrice)}`} <span class="sr-only">Discounted price, previous price</span> <discounted-price>${Shopify.formatMoney(comparePrice)} </discounted-price>`
						if (price) price.innerHTML = html;
					}

					if (name) name.innerHTML = variantName;
					if (nameOnLabels) {
						nameOnLabels.forEach(label => {
							if (label.getAttribute('data-type') == nameOnLabel.getAttribute('data-type')) {
								label.innerHTML = variantName;
							} else {
								label.innerHTML = '';
							}
						});
					}

					var imagesToUpdate = document.querySelectorAll('[data-group-value]');
					if (imagesToUpdate.length > 0) {
						imagesToUpdate.forEach(image => {
							if (image.dataset.groupValue == variantName) {
								if (image.dataset.attribute == 'thumb') {
									document.querySelector('.thumb-slider .swiper-wrapper').prepend(image);
								} else {
									document.querySelector('.main-slider .swiper-wrapper').prepend(image);
								}
							} else {
								if (image.dataset.attribute == 'thumb') {
									document.querySelector('.thumb-slider-other').append(image);
								} else {
									document.querySelector('.main-slider-other').append(image);
								}
							}
						});
						document.querySelector('.thumb-slider').swiper.update()
						document.querySelector('.main-slider').swiper.update()
						document.querySelector('.thumb-slider').swiper.slideTo(0, 0, false)
						document.querySelector('.main-slider').swiper.slideTo(0, 0, false)
					}

					if (skio) {
						const skioOptions = document.querySelectorAll('[data-skio-variant]');
						const variantButton = document.querySelector(`input[data-variant-id="${selectedVariant.id}"]`);


						skioOneTime.innerHTML = variantButton.getAttribute('data-variant-price');

						const subscriptionDiscounted = variantButton.getAttribute('data-skio-subscription-discounted');

						if (subscriptionDiscounted && subscriptionDiscounted.trim() !== '') {
							skio.innerHTML = subscriptionDiscounted;
						} else if (selectedVariant.selling_plan_allocations[0]) {
							skio.innerHTML = Shopify.formatMoney(selectedVariant.selling_plan_allocations[0].price);
						} else {
							skio.innerHTML = variantButton.getAttribute('data-variant-price');
						}
						let selectFirst = true
						skioOptions.forEach((el) => {
							const skioToggle = el.getAttribute('data-skio-variant') === variantSkioPosition ? "remove" : "add"
							el.classList[skioToggle]('hidden');
							if (skioToggle === "add") {
								el.disabled = true;
							} else {
								el.disabled = false;
							}

							if (selectFirst && skioToggle === "remove") {
								el.parentElement.value = el.value;
								el.parentElement.dispatchEvent(new Event('change'));

							}
						})
					}
				});
			}
		});
	});

	const subscriptionInputs = document.querySelectorAll("input[name='skio-subscription-value']");

	subscriptionInputs?.forEach(input => {
		input.addEventListener("change", function () {
			const price = document.querySelectorAll('[data-price]');
			const selectedVariantId = Number(document.querySelector(".variants-container input[type='radio'][name='id_temp']:checked").getAttribute('data-variant-id'));
			const selectedVariant = product.variants.find(v => v.id === selectedVariantId);
			let variantPrice = input.getAttribute('data-skio') == 'subscription' ? selectedVariant.selling_plan_allocations[0].price : selectedVariant.price

			const variantButton = document.querySelector(`input[data-variant-id="${selectedVariant.id}"]`);

			const hasDiscounts = document.querySelector('[discounts-applied]');
			const isSubscription = input.getAttribute('data-skio') === 'subscription';

			let displayPrice;
			if (isSubscription) {
				displayPrice = hasDiscounts
					? variantButton.getAttribute('data-skio-subscription-discounted') || Shopify.formatMoney(selectedVariant.selling_plan_allocations[0]?.price || selectedVariant.price)
					: Shopify.formatMoney(selectedVariant.selling_plan_allocations[0]?.price || selectedVariant.price);
			} else {
				displayPrice = hasDiscounts
					? variantButton.getAttribute('data-variant-price')
					: Shopify.formatMoney(selectedVariant.price);
			}



			if (price.length > 0) {
				price.forEach((ele) => {
					const priceElement = ele.querySelector('.price');
					const salePriceElement = ele.querySelector('.sale-price');

					if (priceElement) {
						priceElement.innerHTML = displayPrice;
					}

					// Sale prices if there aren't discounts
					if (salePriceElement && !hasDiscounts) {
						if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
							salePriceElement.innerHTML = Shopify.formatMoney(selectedVariant.compare_at_price);
							salePriceElement.style.display = '';
						} else {
							salePriceElement.style.display = 'none';
						}
					}
				});
			}
		});
	});
})();

(function () {
	function handleVariantImageChange(swatch) {
		const variantId = swatch.dataset.variantId;
		const productCard = swatch.closest('.custom-product-card');

		const defaultBouncing = productCard.querySelector('.default-bouncing');
		const allBouncingImages = productCard.querySelectorAll('.variant-bouncing-image');
		const selectedBouncingImage = productCard.querySelector(`.variant-bouncing-image.v-${variantId}`);

		allBouncingImages.forEach((image) => {
			image.classList.remove('first-variant');
		});

		if (selectedBouncingImage) {
			selectedBouncingImage.classList.add('first-variant');
			if (defaultBouncing) {
				defaultBouncing.classList.add('hidden');
			}
		} else {
			if (defaultBouncing) {
				defaultBouncing.classList.remove('hidden');
			}
		}

		const allHoverImages = productCard.querySelectorAll('.variant-image');
		const selectedHoverImage = productCard.querySelector(`.variant-image.v-${variantId}`);
		const defaultHoverImage = productCard.querySelector('.hover:not(.variant-image)');

		allHoverImages.forEach((image) => {
			image.classList.remove('first-variant');
		});

		if (selectedHoverImage) {
			selectedHoverImage.classList.add('first-variant');
			if (defaultHoverImage) {
				defaultHoverImage.classList.add('hidden');
			}
		} else {
			if (defaultHoverImage) {
				defaultHoverImage.classList.remove('hidden');
			}
		}
	}

	function handleVariantPriceAndAvailability(swatch) {
		const productCard = swatch.closest('.custom-product-card');
		const variantPrice = swatch.dataset.variantPrice;
		const variantComparePrice = swatch.dataset.variantComparePrice;
		const variantUnfilteredPrice = swatch.dataset.variantUnfilteredPrice; 

		const priceElement = productCard.querySelector('.variant-price');
		if (priceElement && variantPrice) {
			if (variantComparePrice && Number(variantComparePrice) > Number(variantUnfilteredPrice)) {
				priceElement.innerHTML = `
					${variantPrice} 
					<span class="sr-only">Discounted price, previous price</span> 
					<discounted-price>${Shopify.formatMoney(variantComparePrice)}</discounted-price>
				`;
			} else {
				priceElement.innerHTML = variantPrice;
			}
    	}

		const hiddenVariantInput = productCard.querySelector('input[name="id"]');
		if (hiddenVariantInput) {
			hiddenVariantInput.value = swatch.dataset.variantId;
		}

		const addToCartButton = productCard.querySelector('[data-add-to-cart]');
		const isAvailable = swatch.dataset.available === 'true';
		const buttonTextSpan = addToCartButton?.querySelector('span:last-child');

		if (addToCartButton && buttonTextSpan) {
			if (isAvailable) {
				addToCartButton.disabled = false;
				addToCartButton.classList.remove('disabled');
				addToCartButton.style.cursor = 'pointer';
				if (buttonTextSpan.textContent.includes('Out of Stock')) {
					buttonTextSpan.textContent = 'Add To Cart';
				}
			} else {
				addToCartButton.disabled = true;
				addToCartButton.classList.add('disabled');
				addToCartButton.style.cursor = 'not-allowed';
				buttonTextSpan.textContent = 'Out of Stock';
			}
		}
	}

	function handleVariantChange(swatch) {
		handleVariantImageChange(swatch);
		handleVariantPriceAndAvailability(swatch);
		const productCard = swatch.closest('.custom-product-card');
		const productId = productCard
			.querySelector('[data-toggle-variants]')
			?.getAttribute('data-toggle-variants');
		const variantLabel = document.getElementById(`variant-label-${productId}`);

		if (variantLabel) {
			const variantName = swatch.dataset.variantName || swatch.value;
			const firstPart = variantName.split('-')[0];
			variantLabel.textContent = firstPart;
		}
	}

	function initializeDefaultVariant() {
		const productCards = document.querySelectorAll('.custom-product-card');

		productCards.forEach(productCard => {
			const checkedSwatch = productCard.querySelector('.radio_container input[type="radio"]:checked');

			if (checkedSwatch) {
				handleVariantChange(checkedSwatch);
			} else {
				const firstSwatch = productCard.querySelector('.radio_container input[type="radio"]:first-of-type');
				if (firstSwatch) {
					firstSwatch.checked = true;
					handleVariantChange(firstSwatch);
				}
			}
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		const toggleButtons = document.querySelectorAll('.variant-toggle');

		toggleButtons.forEach(button => {
			button.addEventListener('click', function (e) {
				e.preventDefault();

				const productId = this.getAttribute('data-toggle-variants');
				const variantsContainer = document.getElementById('variants-' + productId);
				const addToCartButton = document.getElementById('btn-atc-' + productId);

				if (variantsContainer) {
					if (variantsContainer.classList.contains('desktop-hidden')) {
						variantsContainer?.classList.remove('desktop-hidden');
						this.classList.add('desktop-hidden');
						if (addToCartButton) {
							addToCartButton?.classList.remove('desktop-hidden');
						}

						const productCard = this.closest('.custom-product-card');
						const checkedSwatch = productCard.querySelector('.radio_container input[type="radio"]:checked');
						if (checkedSwatch) {
							handleVariantChange(checkedSwatch);
						}
					}
				}
			});
		});

		let swatches = document.querySelectorAll('.custom-product-card .radio_container input[type="radio"]');
		if (swatches.length > 0) {
			swatches.forEach((swatch) => {
				swatch.addEventListener('change', function () {
					handleVariantChange(this);
				});
			});
		}
		initializeDefaultVariant();
	});

	const productForms = document.querySelectorAll('[id^="product_form"]');
	productForms.forEach((form) => {
		const variantButtons = form.querySelectorAll('[name="id_temp_variant"]');

		if (variantButtons.length === 0) return;

		const price = form.querySelectorAll('[data-price]');

		variantButtons.forEach(function (button) {
			button.addEventListener('click', () => {
				const variantId = button.getAttribute('data-variant-id');

				form.querySelectorAll('[name="id"]').forEach((input) => (input.value = variantId));

				const variantName = button.getAttribute('data-variant-name');
				const variantType = button.getAttribute('data-variant-type');

				const selectedInput = form.querySelector('input[name="id_temp_variant"]:checked');
				const selectedId = Number(selectedInput?.dataset.variantId);

				// Prices updates
				if (price.length > 0) {
					price.forEach((ele) => {
						const priceElement = ele.querySelector('.price');
						const name = ele.querySelector('.variant-name');

						const variantPrice = button.getAttribute('data-variant-price');

						if (priceElement && variantPrice) {
							priceElement.innerHTML = variantPrice;
						}

						if (name) name.innerHTML = variantName;
					});
				}


				const productCard = button.closest('.custom-product-card');
				if (productCard) {
					handleVariantImageChange(button);
				}
			});
		});
	});
})();